import React from "react";
import Portal from "src/shared/components/Portal";
import { t } from "src/shared/locales/i18n";
import { DivCartFailModal } from "../style/CartFailModal.style";

interface Props {}

const CartFailModal = (props: Props) => {
  return (
    <Portal>
      <DivCartFailModal>
        <div className="akn-cart-fail-modal-wrapper">
          <div className="akn-cart-fail-modal" style={{ padding: 25 }}>
            <span
              className="akn-cart-fail-modal__icon"
              style={{ transform: "scale(0.5)" }}
            >
              ❌
            </span>
            <span className="akn-cart-fail-modal__text">
              {t("failed_to_add_cart__wait_for_stream_start")}
            </span>
          </div>
        </div>
      </DivCartFailModal>
    </Portal>
  );
};

export default CartFailModal;
